export default __webpack_public_path__ + "static/media/cut.a35b6305.svg";